"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoreInput = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _useRefSetter = require("../../helpers/useRefSetter");

var _excluded = ["textArea", "disabled", "warning", "cn", "tall", "textAreaHeight", "icons", "shaded", "error", "errorText"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CoreInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var textArea = props.textArea,
      disabled = props.disabled,
      warning = props.warning,
      cn = props.cn,
      tall = props.tall,
      textAreaHeight = props.textAreaHeight,
      icons = props.icons,
      shaded = props.shaded,
      error = props.error,
      errorText = props.errorText,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var innerRef = (0, _react.useRef)(null);
  var setRef = (0, _useRefSetter.useRefSetter)(innerRef, forwardedRef);

  var htmlProps = _objectSpread(_objectSpread({
    className: (0, _classnames.default)(cn.input, (0, _defineProperty2.default)({}, cn.textarea, textArea), (0, _defineProperty2.default)({}, cn.warning, warning), (0, _defineProperty2.default)({}, cn.disabled, disabled), (0, _defineProperty2.default)({}, cn.tall, tall), (0, _defineProperty2.default)({}, cn.with.icon, !!icons), (0, _defineProperty2.default)({}, cn.with.icons, !!icons && icons.length > 1), (0, _defineProperty2.default)({}, cn.shaded, shaded), (0, _defineProperty2.default)({}, cn.error, error)),
    disabled: disabled
  }, rest), {}, {
    ref: setRef
  });

  (0, _react.useEffect)(function () {
    var lineHeight = window.getComputedStyle(innerRef.current).lineHeight;
    innerRef.current.style.height = textArea ? "calc(".concat(lineHeight, " * ").concat(textAreaHeight, ")") : 'auto';
  }, [textArea, textAreaHeight]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, !icons ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.icons
  }, icons.map(function (icon, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: cn.icon
    }, icon);
  })), textArea ? /*#__PURE__*/_react.default.createElement("textarea", htmlProps) : /*#__PURE__*/_react.default.createElement("input", htmlProps)), errorText && /*#__PURE__*/_react.default.createElement("div", {
    className: cn.errorText
  }, errorText));
});
exports.CoreInput = CoreInput;
CoreInput.propTypes = {
  /* component logic props */
  textArea: _propTypes.bool,
  disabled: _propTypes.bool,
  textAreaHeight: _propTypes.number,
  icons: (0, _propTypes.arrayOf)(_propTypes.node),
  errorText: _propTypes.string,

  /* styling modificators */
  warning: _propTypes.bool,
  tall: _propTypes.bool,
  shaded: _propTypes.bool,
  error: _propTypes.bool,

  /* binded classes */
  cn: _propTypes.object.isRequired
};
CoreInput.defaultProps = {
  icons: null,
  textAreaHeight: 8,
  errorText: '',
  textArea: false,
  tall: false,
  disabled: false,
  warning: false,
  shaded: false,
  error: false
};